import styled from "styled-components";

export const TextWrapper = styled.div`
  max-width: 34.4rem;
`;
